import React from "react";
import { travianCurrentServer } from '../../../travianCore';
import {formatCoordinates, formatCoordinatesShort, id2xy, xy2id} from '../../../travian/coordinates';
import BasedOnVersion from "./travianVersionHelper";
import {getAllianceById, getKingdomById, getPlayerById, getVillageById} from "../../../travian/worldData";
import {linkToSendAttack} from "../../../travian/links.js";

function Link({ href, ...props }) {
    return <a href={href} target='_blank' {...props} />;
}

export function PlayerLink({ uid, name, autoName = true, ...props }) {
    if(autoName && name === undefined) {
        name = getPlayerById(uid)?.name ?? 'uid:' + uid;
    }
    return (
        <BasedOnVersion
            legends={<Link href={`https://${travianCurrentServer}/profile/${uid}`} {...props}>{name ?? props.children}</Link>}
            kingdoms={<Link href={`https://${travianCurrentServer}/#/playerId:${uid}/window:profile/profileTab:playerProfile`} {...props}>{name ?? props.children}</Link>}
        />
    )
}

export function VillageLink({ vid, name, autoName = true, ...props }) {
    const { x, y } = id2xy(vid);
    if(autoName && name === undefined) {
        name = getVillageById(vid)?.sname ?? null;
        name = name === null ? formatCoordinates({ x, y }) : (name + ' ' + formatCoordinatesShort({ x, y }));
    }
    return (
        <BasedOnVersion
            legends={<Link href={`https://${travianCurrentServer}/position_details.php?x=${x}&y=${y}`} {...props}>{name ?? props.children}</Link>}
            kingdoms={<Link href={`https://${travianCurrentServer}/#/page:map/centerId:${vid}_0`} {...props}>{name ?? props.children}</Link>}
        />
    )
}

export function KingdomLink({ kid, name, autoName = true, ...props }) {
    if(autoName && name === undefined) {
        name = getKingdomById(kid)?.tag ?? 'kid:' + kid;
    }
    return (
        <BasedOnVersion
            kingdoms={<Link href={`https://${travianCurrentServer}/#/kingdomId:${kid}/window:kingdom/`} {...props}>{name ?? props.children}</Link>}
        />
    )
}

export function AllianceLink({ aid, name, autoName = true, ...props }) {
    if(autoName && name === undefined) {
        name = getAllianceById(aid)?.name ?? 'aid:' + aid;
    }
    return (
        <BasedOnVersion
            legends={<Link href={`https://${travianCurrentServer}/alliance/${aid}`} {...props}>{name ?? props.children}</Link>}
        />
    )
}

export function GroupLink({ gid, name, autoName = true, ...props }) {
    return (
        <BasedOnVersion
            legends={<AllianceLink aid={gid} name={name} autoName={autoName} {...props} />}
            kingdoms={<KingdomLink kid={gid} name={name} autoName={autoName} {...props} />}
        />
    )
}

/**
 *
 * @param targetVillageId
 * @param sourceVillageId For T:L, this needs to be "did" (as in newdid), not "kid" (as in z=...).
 * @param props
 * @constructor
 */
export function SendAttack({ targetMapId, sourceVillageId, eventType, troops, targetX, targetY, ...props }) {
    if (targetMapId === undefined) {
        targetMapId = xy2id({ x: targetX, y: targetY });
    }
    if (targetX === undefined && targetY === undefined) {
        const { x, y } = id2xy(targetMapId);
        targetX = x;
        targetY = y;
    }
    return (
        <BasedOnVersion
            legends={<Link href={linkToSendAttack({ targetMapId, sourceVillageId, eventType, troops, targetX, targetY })} {...props} />}
            kingdoms={<Link href={`https://${travianCurrentServer}/#/page:map/centerId:${targetMapId}_0/window:sendTroops/x:${targetX}/y:${targetY}`} {...props} />}
        />
    )
}
